/*
 * @Author: mayanxia 
 * @Date: 2020-08-28 21:49:25 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-04 17:51:14
 */
 <style scoped lang="less">
 #top-header{
   background: url('~@/assets/images/top-header.png') #071737 no-repeat;
   background-size: 100% 100%;
   display: flex;
   color: #fff;
 }
</style>
<template>
  <div id="top-header" style="width: 520px;height: 85px">
    <!-- <div style="width: 80px;" class="flex-center flex-column">
      <div style="line-height: 0.8">年度缴费</div>
      <div class="font-18" style="font-weight: bold;color:#00FAFE">
        <span>{{curYearPayValue}}</span>
        </div>
    </div> -->
    <div class="flex-center flex" style="width: calc(100% - 80px);">
      <div class="flex-center flex-item" v-for="item in totalList" :key="item.key">
        <!-- <i class="iconfont iconshuiliang" style="margin-right: 10px;color: #00F0FD;font-size: 30px"></i> -->
        <div><img class="item-image" :src="item.imgSrc" /></div>
        <div class="flex-column" style="flex: 1;padding-left: 20px">
          <div :style="'color:'+color">{{item.title}}</div>
          <div :style="'color:'+valueColor " style="line-height: 1">
            <span class="ds-digital-bold font-38">
              <animated-integer :value="item.sum"></animated-integer>
            </span>
            <span class="unit" :style="'color: '+unitColor">{{item.unit}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import animatedInteger from '@/components/maComponents/animated-integer';
import { putAction } from '@/api/manage';
import {isNull} from '@/utils/validate'
export default {
  components: {
    animatedInteger
  },
  data() {
    return {
      color: '#01B8FD',
      valueColor: '#A8C6F3',
      unitColor: '#A8C6F3',
      totalList: [
        //{title: '总取水量',sum: 0,icon: '',unit: 'm³',key: 1},
        {title: this.$t('年度总缴费'),sum: 0,icon: '',unit: this.$t('元'),key: 3,imgSrc: require("@/assets/images/pay-icon.png")},
        {title: this.$t('年度总用量'),sum: 0,icon: '',unit: 'm³',key: 2,imgSrc: require("@/assets/images/water-icon.png")},
      ],
      url: {
        payMoneyCount: '/jeecg-charge/meter/waterAnalysis/payMoneyCount',
        waterUse: '/jeecg-charge/meter/waterAnalysis/waterUse'
      },
      curYearPay: 0,// 年度总缴费
    }
  },
  computed: {
    curYearPayValue() {
      if(isNull(this.curYearPay)) {
        return this.$t('0元')
      }
      if(Number(this.curYearPay)>=10000) {
        return parseInt((Number(this.curYearPay)/10000)*10)/10+this.$t('万元')
      }else {
        return Number(this.curYearPay)+this.$t('元')
      }
    }
  },
  methods: {
    init() {
      console.log("lalalalla ")
      this.resetData()
      this.setData()
    },
    resetData() {
      this.totalList = this.$options.data.call(this).totalList
      console.log(this.totalList)
    },
    setData() {
      this.querywaterUseTotal();
      this.queryPayMoneyCount();
    },
    querywaterUseTotal() {
      putAction(this.url.waterUse, {}).then((res) => {
        if(res.success){
          this.totalList[1].sum = res.result.waterUseYear
        }
      })
    },
    queryPayMoneyCount() {
      putAction(this.url.payMoneyCount, {}).then((res) => {
        if(res.success){
          this.totalList[0].sum = res.result.curYearPay
          this.curYearPay = this.totalList[0].sum;
        }
      })
    },
  }
}
</script>
